var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      staticClass: "font-weight-bold",
      attrs: {
        href: "https://courses.plschool.ru/",
        variant: "custom-green",
        target: "_blank",
      },
    },
    [_vm._v("ОБУЧАЮЩИЙ КУРС")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }